import Vue from 'vue';
import UserProxy from '@/proxies/User';
import UserTransform from '@/transforms/User';
import * as types from './mutation-types';
import {
  addTokenToStorage,
  clearTokenToStorage,
  getToken,
} from '@/utils/session';

export default {
  async profile({ commit, dispatch }) {
    const proxy = new UserProxy();
    try {
      const response = await proxy.getProfile();
      commit(types.SET_PROFILE, UserTransform.fetch(response));
      dispatch('setLanguage', 'en', { root: true });
      // dispatch('setLanguage', response.language, { root: true });
    } catch (e) {
    }
  },
  async changeLanguage({ dispatch }, payload) {
    // const proxy = new UserProxy();
    try {
      // await proxy.setProfile({ language: payload });
      dispatch('setLanguage', payload);
      dispatch('setLanguage', payload, { root: true });
      dispatch('dialog/close', null, { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_change_language', { root: true });
    }
  },
  setLanguage({ commit }, payload) {
    commit(types.SET_LANGUAGE, payload.toLowerCase());
  },

  clearToken({ commit }) {
    clearTokenToStorage();
    commit(types.SET_AUTHENTICATE, false);
  },

  initializeAuth({ commit, dispatch }) {
    const token = getToken();
    if (token) {
      commit(types.SET_AUTHENTICATE, true);
    } else {
      dispatch('clearToken');
    }
  },

  async login({ commit, dispatch }, payload) {
    const { setLoading, ...params } = payload;
    try {
      setLoading(true);
      const proxy = new UserProxy();
      const { token } = await proxy.login(params);

      if (token) {
        addTokenToStorage(token);
        commit(types.SET_AUTHENTICATE, true);
        Vue.router.push({ name: Vue.$app.route.PROJECTS });
      } else {
        await dispatch('logout');
        dispatch('login', payload);
      }
    } catch (error) {
      console.log(error);
      commit(types.SET_AUTHENTICATE, false);
      dispatch('notification/error', 'errormessage.invalid_login_or_password', { root: true });
    } finally {
      setLoading(false);
    }
  },

  async logout({ dispatch }) {
    const proxy = new UserProxy();
    try {
      await proxy.logout();
      dispatch('clearToken');
      Vue.router.push({ name: Vue.$app.route.LOGIN });
    } catch (e) {
      console.log(e);
    }
  }
};
